(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/my-profile-react/assets/constants.js') >= 0) return;  svs.modules.push('/modules/my-profile-react/assets/constants.js');
'use strict';

const isServer = typeof exports === 'object';
const routes = {
  MY_PROFILE_HOME: '/',
  MY_PROFILE_INFORMATION: '/uppgifter',
  MY_PROFILE_TRANSCRIPT: '/uppgifter/registerutdrag',
  MY_PROFILE_PLAYERDETAILS_CONFIRM_MOBILE: '/uppgifter/bekrafta-mobil',
  MY_PROFILE_PLAYERDETAILS_CHANGE_MOBILE: '/uppgifter/mobil',
  MY_PROFILE_PLAYERDETAILS_CONFIRM_EMAIL: '/uppgifter/bekrafta-epost',
  MY_PROFILE_PLAYERDETAILS_MISSING_EMAIL: '/uppgifter/saknar-epost',
  MY_PROFILE_PLAYERDETAILS_CHANGE_EMAIL: '/uppgifter/epost',
  MY_PROFILE_COMMUNICATION: '/kommunikation',
  MY_PROFILE_COMMUNICATION_ADAPT_CONTENT: '/kommunikation/anpassat-innehall',
  MY_PROFILE_NOTIFICATIONS: '/spelnotifieringar',
  MY_PROFILE_KYC: '/kundkannedom',
  MY_PROFILE_KYC_QUESTIONS: '/kundkannedom/svara'
};
const syndicateMailId = {
  WITHDRAWAL: 5,
  DEPOSIT: 6,
  TERMINATED: 8,
  ACCEPT_INVITATION: 9,
  REJECT_INVITATION: 10,
  BET: 14,
  CANCEL_BET: 15,
  TRANSFER_MONEY: 16,
  WIN: 19,
  REMOVED_MEMBER_OWN: 21,
  INACTIVATED_OWN: 25,
  WITHDRAWAL_BY_MEM: 26
};
const emailStatuses = {
  DELETED: '0',
  BOUNCE: '1',
  VERIFIED: '2',
  OFFERED_VERIFICATION_ACTIVE: '3',
  NOT_OFFERED_VERIFICATION: '4',
  OFFERED_VERIFICATION_EXPIRED: '5'
};
const thunkStatus = {
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected',
  INITIAL: 'initial'
};
const checkboxNotification = {
  TRACK_MAIL: 'trackMail',
  TRACK_LINK: 'trackLink',
  TRACK_WIN: 'trackWin'
};
const titles = {
  ADAPT: 'Anpassat innehåll',
  OFFERS: 'Erbjudanden och annonsering hos samarbetspartners',
  HELP: 'Hjälp oss bli bättre',
  NEWS: 'Nyheter och marknadsföring',
  CORRECT: 'Rättning och påminnelser',
  PLAYTOGETHER: 'Spela tillsammans',
  FRACTIONGAME: 'Andelsspel online',
  LUCK: 'Tur'
};
const icons = {
  ADAPT: 'customized-content',
  OFFERS: 'nav-sportservice',
  HELP: 'chat-host',
  NEWS: 'news',
  CORRECT: 'win',
  PLAYTOGETHER: 'spela-tillsammans',
  FRACTIONGAME: 'andelsspel'
};
const backendName = {
  CORRECTION_MAIL_KENO: 'correctionMailKeno',
  CORRECTION_MAIL_VIKING_LOTTO: 'correctionMailVikinglotto',
  CORRECTION_MAIL_EUROJACKPOT: 'correctionMailEurojackpot',
  CORRECTION_MAIL_LOTTO: 'correctionMailLotto',
  WIN_RESULTS: 'winResults',
  RECURRING_WAGER_REMINDERS: 'recurringWagerReminders',
  ADVERTING_EMAIL: 'advertisingEmail',
  ADVERTISING_SMS: 'advertisingSms',
  ADVERTISING_LETTER: 'advertisingLetter',
  VEGAS_COMMUNICATION: 'vegasCommunication',
  ADVERTISING_APP_NOTIFICATION: 'advertisingAppNotification',
  MARKET_RESEARCH: 'marketResearch'
};
const exportConstants = {
  routes,
  syndicateMailId,
  emailStatuses,
  thunkStatus,
  checkboxNotification,
  titles,
  icons,
  backendName
};
if (isServer) {
  module.exports = exportConstants;
} else {
  svs.myProfile.constants = exportConstants;
}

 })(window);